const appKeyActionTypes = {
  SAVE_KEY: "SAVE_KEY",
  SAVE_BASE_URL: "SAVE_BASE_URL",
  SAVE_ACCOUNT_LANG: "SAVE_ACCOUNT_LANG",
  GET_ACCOUNT_CONFIG_START: "GET_ACCOUNT_CONFIG_START",
  GET_ACCOUNT_CONFIG_FAILED: "GET_ACCOUNT_CONFIG_FAILED",
  GET_USER_RIGHTS_START: "GET_USER_RIGHTS_START",
  GET_USER_RIGHTS_SUCCESS: "GET_USER_RIGHTS_SUCCESS",
  GET_USER_RIGHTS_FAILED: "GET_USER_RIGHTS_FAILED",
  GET_USER_LANG_SUCCESS: "GET_USER_LANG_SUCCESS",
  GET_USER_LANG_FAILED: "GET_USER_LANG_FAILED",
  GET_USER_LANG_START: "GET_USER_LANG_START",
  GET_SESSION_USER_START: "GET_SESSION_USER_START",
  GET_SESSION_USER_SUCCESS: "GET_SESSION_USER_SUCCESS",
  GET_SESSION_USER_FAILED: "GET_SESSION_USER_FAILED",
  GET_FIELD_PERMISSIONS_SUCCESS: "GET_FIELD_PERMISSIONS_SUCCESS",
  GET_FIELD_PERMISSIONS_FAILED: "GET_FIELD_PERMISSIONS_FAILED",
  GET_FRANCHAISE_START: "GET_FRANCHAISE_START",
  GET_FRANCHAISE_SUCCESS: "GET_FRANCHAISE_SUCCESS",
  GET_FRANCHAISE_FAILED: "GET_FRANCHAISE_FAILED",
};

export default appKeyActionTypes;
